export interface AuthActionError {
  title: string;
  message: string;
}

export interface AuthActionData {
  error?: AuthActionError;
  message?: string;
}

export const createAuthActionError = (title: string, message: string): AuthActionData => ({
  error: { title, message },
  message,
});

const normalizeErrorMessage = (message: unknown, fallback: string) => {
  if (Array.isArray(message)) {
    const messageParts = message.filter((part): part is string => typeof part === 'string' && part.trim().length > 0);
    return messageParts.length > 0 ? messageParts.join(' ') : fallback;
  }

  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  return fallback;
};

export const getResponseErrorMessage = async (response: Response, fallback: string) => {
  const errorData = await response.json().catch(() => null);
  return normalizeErrorMessage(errorData?.message, fallback);
};

export const getNetworkAuthError = (mode: 'login' | 'register') => {
  const action = mode === 'login' ? 'sign you in' : 'create your account';
  return createAuthActionError(
    'Connection issue',
    `We could not ${action} because the server is not reachable right now. Please make sure the backend is running, then try again.`
  );
};
